import { render, staticRenderFns } from "./EntityAddress.vue?vue&type=template&id=a0cc27a2"
import script from "./EntityAddress.vue?vue&type=script&lang=js"
export * from "./EntityAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports